import SimpleTooltip from '@rio-cloud/rio-uikit/components/tooltip/SimpleTooltip';
import { PLACEMENT } from '@rio-cloud/rio-uikit/values/Placement';

import { t } from '@/lib/utils';

interface OrderHeaderProps {
    orderId: string;
}

const OrderHeader = ({ orderId }: OrderHeaderProps) => (
    <>
        <span className='text-medium'>{t('orderHistory.orderId')}:</span>
        <span className='padding-left-2'>{orderId}</span>
        <SimpleTooltip content={t('orderHistory.orderId.tooltip')} placement={PLACEMENT.TOP_START} width={350}>
            <span className='rioglyph rioglyph-info-sign text-color-light text-size-16 padding-left-2' />
        </SimpleTooltip>
    </>
);

export default OrderHeader;
